import { LogOutIcon } from 'lucide-react'

import { signOut } from '@/app/actions/auth'
import { Button } from '@/components/ui/button'
import { useCurrentUser } from '@/hooks/useCurrentUser'

/**
 * Footer sign-out control. The user is loaded after mount so page renders stay static.
 */
export const FooterSignOut: React.FC = () => {
  const payloadUser = useCurrentUser()

  if (payloadUser === undefined) {
    return <div className="invisible h-10 w-28" />
  }

  return (
    <>
      {payloadUser ? (
        <Button
          variant="outline"
          customIcon={<LogOutIcon className="size-2.5" />}
          className="self-center md:w-fit md:self-end"
          onClick={() => signOut()}
        >
          Sign out
        </Button>
      ) : (
        <div className="invisible h-10 w-28" />
      )}
    </>
  )
}
